/* GRACE — theme behaviour. Load deferred in theme.liquid. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function t(key, fallback) {
    var strings = window.GraceStrings || {};
    return strings[key] || fallback || '';
  }

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.GraceMoneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Scroll reveal — 24px rise, 60ms stagger, once. */
  function reveals() {
    var els = document.querySelectorAll('.grace-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var i = parseInt(el.getAttribute('data-reveal-index') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, i * 60);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Category tabs */
  function tabs(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-grace-tabs]').forEach(function (group) {
      if (group.dataset.graceBound) return;
      group.dataset.graceBound = '1';
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tab]');
        if (!btn) return;
        var id = btn.getAttribute('data-tab');
        var wrap = group.closest('[data-grace-tabgroup]') || document;
        group.querySelectorAll('[data-tab]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        wrap.querySelectorAll('[data-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
        });
      });
    });
  }

  /* Full-screen menu */
  function menu() {
    var panel = document.querySelector('[data-grace-menu]');
    if (!panel) return;
    function open(state) {
      panel.classList.toggle('is-open', state);
      document.documentElement.style.overflow = state ? 'hidden' : '';
      panel.setAttribute('aria-hidden', state ? 'false' : 'true');
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-grace-menu-open]')) { e.preventDefault(); open(true); }
      if (e.target.closest('[data-grace-menu-close]')) { e.preventDefault(); open(false); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  /* Announcement rotator — max two messages, 6s each */
  function announce() {
    document.querySelectorAll('[data-grace-announce]').forEach(function (bar) {
      var items = bar.querySelectorAll('.grace-announce__item');
      if (items.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 6000);
    });
  }

  /* PDP sticky buy bar */
  function stickyBuy() {
    var bar = document.querySelector('[data-grace-sticky-buy]');
    var anchor = document.querySelector('[data-grace-buy-block]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- CART ---------------------------------------- */

  function updateCartCount(count) {
    document.querySelectorAll('[data-grace-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; });
  }

  function toast(message, isError) {
    var el = document.querySelector('[data-grace-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'grace-toast';
      el.setAttribute('data-grace-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(el._graceTimer);
    el._graceTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function addToCart(variantId, quantity, button) {
    var original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = t('adding', 'Adding…'); }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || t('cart_error', 'Could not add to bag'));
          return data;
        });
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        toast(t('added', 'Added to bag'));
        if (button) { button.textContent = t('added', 'Added to bag'); }
        setTimeout(function () {
          if (button) { button.disabled = false; button.textContent = original; }
        }, 1600);
      })
      .catch(function (err) {
        toast(err.message, true);
        if (button) { button.disabled = false; button.textContent = original; }
      });
  }

  /* Quick add from product cards */
  function quickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-grace-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-grace-quick-add');
      if (id) addToCart(id, 1, btn);
    });
  }

  /* PDP add-to-cart forms */
  function productForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-grace-product-form]');
      if (!form) return;
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var button = form.querySelector('[type="submit"]');
      if (!idInput || !idInput.value) return;
      addToCart(idInput.value, qtyInput ? Number(qtyInput.value) : 1, button);
    });
  }

  /* Variant selection on PDP */
  function variants() {
    document.querySelectorAll('[data-grace-variants]').forEach(function (root) {
      if (root.dataset.graceBound) return;
      root.dataset.graceBound = '1';

      var data;
      var script = root.querySelector('[data-grace-variant-data]');
      try { data = JSON.parse(script.textContent); } catch (err) { return; }

      var idInput = root.querySelector('[name="id"]');
      var priceEl = root.querySelector('[data-grace-price]');
      var submit = root.querySelector('[data-grace-submit]');
      var stickyPrice = document.querySelector('[data-grace-sticky-price]');

      function currentOptions() {
        return Array.prototype.map.call(
          root.querySelectorAll('[data-grace-option-group]'),
          function (group) {
            var sel = group.querySelector('[data-grace-option].is-selected');
            return sel ? sel.getAttribute('data-value') : null;
          }
        );
      }

      function findVariant(opts) {
        return data.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function renderPrice(variant) {
        if (!priceEl) return;
        if (!variant) { priceEl.innerHTML = ''; return; }
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<del>' + money(variant.compare_at_price) + '</del> <ins>' + money(variant.price) + '</ins>';
        } else {
          html = money(variant.price);
        }
        priceEl.innerHTML = html;
        if (stickyPrice) stickyPrice.innerHTML = html;
      }

      function update() {
        var opts = currentOptions();
        var variant = findVariant(opts);

        // Mark option values that lead to no purchasable variant
        root.querySelectorAll('[data-grace-option-group]').forEach(function (group, gi) {
          group.querySelectorAll('[data-grace-option]').forEach(function (btn) {
            var probe = opts.slice();
            probe[gi] = btn.getAttribute('data-value');
            var match = data.find(function (v) {
              return v.options.every(function (o, i) {
                return i === gi ? o === probe[gi] : (opts[i] == null || o === opts[i]);
              });
            });
            btn.classList.toggle('is-unavailable', !match || !match.available);
          });
        });

        if (idInput) idInput.value = variant ? variant.id : '';
        renderPrice(variant);

        if (submit) {
          var ok = variant && variant.available;
          submit.disabled = !ok;
          submit.textContent = variant
            ? (variant.available ? t('add_to_bag', 'Add to bag') : t('sold_out', 'Sold out'))
            : t('unavailable', 'Unavailable');
        }

        if (variant && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-grace-option]');
        if (!btn) return;
        e.preventDefault();
        var group = btn.closest('[data-grace-option-group]');
        group.querySelectorAll('[data-grace-option]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        update();
      });

      update();
    });
  }

  /* PDP gallery */
  function gallery() {
    document.querySelectorAll('[data-grace-gallery]').forEach(function (root) {
      if (root.dataset.graceBound) return;
      root.dataset.graceBound = '1';
      var main = root.querySelector('[data-grace-gallery-main]');
      root.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-grace-thumb]');
        if (!thumb || !main) return;
        e.preventDefault();
        main.src = thumb.getAttribute('data-full');
        main.alt = thumb.getAttribute('data-alt') || '';
        root.querySelectorAll('[data-grace-thumb]').forEach(function (b) {
          b.classList.toggle('is-active', b === thumb);
        });
      });
    });
  }

  /* PDP quantity stepper (local, pre-add-to-cart) */
  function quantityNudge() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-grace-qty-nudge]');
      if (!btn) return;
      e.preventDefault();
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var min = Number(input.getAttribute('min') || 1);
      var next = Number(input.value) + Number(btn.getAttribute('data-grace-qty-nudge'));
      if (next < min) next = min;
      input.value = next;
    });
  }

  /* Cart line quantity + remove */
  function cartLines() {
    var root = document.querySelector('[data-grace-cart]');
    if (!root) return;

    function change(line, quantity) {
      root.classList.add('is-loading');
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () {
          root.classList.remove('is-loading');
          toast(t('cart_error', 'Could not update the bag'), true);
        });
    }

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-grace-line-remove]');
      if (remove) {
        e.preventDefault();
        change(remove.getAttribute('data-grace-line-remove'), 0);
        return;
      }
      var step = e.target.closest('[data-grace-qty-step]');
      if (step) {
        e.preventDefault();
        var input = step.parentElement.querySelector('[data-grace-qty]');
        if (!input) return;
        var next = Number(input.value) + Number(step.getAttribute('data-grace-qty-step'));
        if (next < 0) next = 0;
        change(input.getAttribute('data-line'), next);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-grace-qty]');
      if (!input) return;
      change(input.getAttribute('data-line'), input.value);
    });
  }

  /* Accordions — FAQ, PDP details */
  function accordions() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-grace-accordion-trigger]');
      if (!trigger) return;
      e.preventDefault();
      var item = trigger.closest('[data-grace-accordion]');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Collection sort — submit on change */
  function collectionControls() {
    document.querySelectorAll('[data-grace-sort]').forEach(function (select) {
      if (select.dataset.graceBound) return;
      select.dataset.graceBound = '1';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* Product recommendations — replace the fallback grid once Shopify responds */
  function related() {
    document.querySelectorAll('[data-grace-related]').forEach(function (root) {
      if (root.dataset.graceLoaded) return;
      root.dataset.graceLoaded = '1';
      var url = root.getAttribute('data-url');
      if (!url) return;

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-grace-related] .grace-grid');
          var target = root.querySelector('.grace-grid');
          // Only replace when Shopify actually returned recommendations.
          if (fresh && fresh.children.length && target) {
            target.replaceWith(fresh);
            reveals();
          }
        })
        .catch(function () { /* keep the server-rendered fallback */ });
    });
  }

  /* Localization (language) forms submit on change.
     Markup comes from Shopify's {% form 'localization' %} tag, so we match on
     the class we pass it rather than a data attribute. */
  function localization() {
    document.querySelectorAll('.grace-localization select').forEach(function (select) {
      if (select.dataset.graceBound) return;
      select.dataset.graceBound = '1';
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });
  }

  function init() {
    reveals();
    tabs();
    menu();
    announce();
    stickyBuy();
    quickAdd();
    productForms();
    variants();
    gallery();
    quantityNudge();
    cartLines();
    accordions();
    collectionControls();
    related();
    localization();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  /* Theme editor re-renders */
  document.addEventListener('shopify:section:load', function (e) {
    reveals();
    tabs(e.target);
    variants();
    gallery();
    collectionControls();
    localization();
  });
})();
